var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMastercard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 149,
    viewBox: "0 0 241 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3617_14882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.093 16.4224H88.1963V133.044H153.093V16.4224Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3173 74.7335C92.3071 63.502 94.8522 52.4153 99.76 42.3128C104.668 32.2104 111.81 23.3569 120.645 16.4226C109.704 7.82247 96.5636 2.47418 82.7264 0.989024C68.8892 -0.496136 54.9133 1.94171 42.3961 8.02401C29.8789 14.1063 19.3255 23.5877 11.9421 35.3843C4.55872 47.1809 0.643311 60.8168 0.643311 74.7335C0.643311 88.6502 4.55872 102.286 11.9421 114.083C19.3255 125.879 29.8789 135.361 42.3961 141.443C54.9133 147.525 68.8892 149.963 82.7264 148.478C96.5636 146.993 109.704 141.645 120.645 133.044C111.81 126.11 104.668 117.257 99.7602 107.154C94.8523 97.0516 92.3071 85.965 92.3173 74.7335Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.643 74.7335C240.644 88.65 236.729 102.286 229.346 114.082C221.963 125.879 211.41 135.36 198.893 141.443C186.376 147.525 172.4 149.963 158.563 148.478C144.726 146.993 131.586 141.645 120.645 133.044C129.473 126.103 136.609 117.248 141.516 107.147C146.423 97.0464 148.973 85.9632 148.973 74.7335C148.973 63.5037 146.423 52.4206 141.516 42.3197C136.609 32.2188 129.473 23.3639 120.645 16.4226C131.586 7.82244 144.726 2.47415 158.563 0.989005C172.4 -0.496136 186.376 1.94181 198.893 8.02418C211.41 14.1066 221.963 23.5879 229.346 35.3845C236.729 47.1811 240.644 60.817 240.643 74.7335Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.568 120.692V118.305H234.53V117.818H232.078V118.305H233.042V120.692H233.568ZM238.328 120.692V117.813H237.576L236.712 119.794L235.847 117.813H235.095V120.692H235.626V118.521L236.436 120.393H236.987L237.797 118.516V120.692H238.328Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3617_14882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 149,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mastercard.ae3ef6ab27ca40140e448e1c147313b6.svg";